import React from 'react';
import { injectIntl } from 'react-intl';
import { DatePicker, SelectField, TextField } from 'material-ui';
import _ from 'lodash';

const filterTranslationAttributes = (attributes) => {
  const filteredAttributes = {};

  // eslint-disable-next-line no-restricted-syntax
  for (const key in attributes) {
    if (key !== 'intl' && key !== 'translated') {
      filteredAttributes[key] = attributes[key];
    }
  }

  return filteredAttributes;
};

export const renderTextField = (props) => {
  const {
    // eslint-disable-next-line react/prop-types
    input,
    // eslint-disable-next-line react/prop-types
    label,
    // eslint-disable-next-line react/prop-types
    type,
    // eslint-disable-next-line react/prop-types
    meta: {
      touched,
      error,
    },
    ...custom
  } = props;

  return (
    <TextField
      hintText={label}
      floatingLabelText={label}
      errorText={touched && error}
      errorStyle={{ float: 'left' }}
      fullWidth
      id={`mui-${_.kebabCase(input.name)}`}
      type={type}
      {...input}
      {...custom}
    />
  );
};

export const renderDatePicker = injectIntl((props) => {
  const {
    input,
    label,
    meta: { touched, error },
    intl,
    translated = true,
    ...custom
  } = props;
  const strLabel = translated ? intl.formatMessage({ id: label }) : label;

  const onChange = (evt, date) => {
    if (input.onChange) {
      input.onChange(date);
    }
  };

  return (
    <DatePicker
      hintText={strLabel}
      container="inline"
      mode="landscape"
      errorText={touched && error}
      errorStyle={{ float: 'left' }}
      fullWidth
      textFieldStyle={{ marginTop: '24px' }}
      onChange={onChange}
      DateTimeFormat={Intl.DateTimeFormat}
      id={`mui-${_.kebabCase(input.name)}`}
      {...filterTranslationAttributes(custom)}
      okLabel={intl.formatMessage({ id: 'app.forms.date_picker.label.ok' })}
      cancelLabel={intl.formatMessage({ id: 'app.forms.date_picker.label.cancel' })}
    />
  );
});

export const renderSelectField = injectIntl((props) => {
  const {
    input,
    label,
    meta: { touched, error },
    children,
    intl,
    translated = true,
    ...custom
  } = props;

  const strLabel = translated ? intl.formatMessage({ id: label }) : label;

  return (
    <SelectField
      floatingLabelText={strLabel}
      errorText={touched && error}
      fullWidth
      id={`mui-${_.kebabCase(input.name)}`}
      onChange={(event, index, value) => input.onChange(value)}
      name={input.value}
      value={input.value}
      {...filterTranslationAttributes(custom)}
      style={{
        ...custom.style,
        marginTop: '0',
      }}
    >
      {children}
    </SelectField>
  );
});
